import { createAction } from '@reduxjs/toolkit'

export const SCHEDULE_EXPORT = 'SCHEDULE_EXPORT'

export const scheduleExport = createAction(SCHEDULE_EXPORT)
